module.exports = __webpack_public_path__ + "img/nz.49ad21ad.svg";